import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";




const AddPostSite = () => {
    document.title = "DirtMap - Add Listing";

    const history = useHistory();
    const [image, setImage] = useState([]);
    const [video, setVideo] = useState([]);
    const [document, setDocument] = useState([]);
    const [errorlist, setError] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();


    const [postSiteInput, setPostSiteInput] = useState({
        user_id: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0,
        item_type: '',
        project_name: '',
        cuyds_of_dirt_min: '',
        //cuyds_of_dirt_max: '',
        address: '',
        latitude: '20.20',
        longitude: '30.30',
        description: '',
        special_instruction: '',
        name: '',
        email: '',
        phone: '',
        status: ''
    })

    //const [postSiteFile, setPostSiteFile] = useState([]);

    const handleInput = (e) => {
        e.persist();
        setPostSiteInput({ ...postSiteInput, [e.target.name]: e.target.value });
    }

    const handleImage = (e) => {
        e.persist();
        setImage({ image: e.target.files[0] });
    }
    const handleVideo = (e) => {
        e.persist();
        setVideo({ video: e.target.files[0] });
    }
    const handleDocument = (e) => {
        e.persist();
        setDocument({ document: e.target.files[0] });
    }

    const submitPostSite = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('image', image.image);
        formData.append('document', document.document);
        formData.append('video', video.video);

        formData.append('user_id', postSiteInput.user_id);
        formData.append('email', postSiteInput.email);
        formData.append('item_type', postSiteInput.item_type);
        formData.append('project_name', postSiteInput.project_name);
        formData.append('cuyds_of_dirt_min', postSiteInput.cuyds_of_dirt_min);
        //formData.append('cuyds_of_dirt_max', postSiteInput.cuyds_of_dirt_max);
        formData.append('address', postSiteInput.address);
        formData.append('latitude', postSiteInput.latitude);
        formData.append('longitude', postSiteInput.longitude);
        formData.append('description', postSiteInput.description);
        formData.append('special_instruction', postSiteInput.special_instruction);
        formData.append('name', postSiteInput.name);
        formData.append('email', postSiteInput.email);
        formData.append('phone', postSiteInput.phone);
        formData.append('status', postSiteInput.status);

        showLoader();
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/create/post/site`, formData).then(res => {
                if (res.data.success === true) {
                    console.log('success');
                    hideLoader();
                    swal("success", res.data.message, "success");
                    history.push('/admin/post-site/index');
                    setError([]);
                }
                else {
                    hideLoader();
                    setError(res.data.errors);
                    //setPostSiteInput({ ...postSiteInput, error_list: res.data.errors });
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Create Listings</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={submitPostSite} enctype="multipart/form-data">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Item Type</label>

                                    <select name="item_type" onChange={handleInput} value={postSiteInput.item_type} className="form-control">
                                        <option value="">Type</option>
                                        <option value="import">Soil Import</option>
                                        <option value="export">Soil Export</option>
                                        <option value="dump_site">Dump Site</option>
                                        <option value="truks">Trucks</option>
                                    </select>
                                    <span className="validate-error-message">{errorlist.item_type}</span>

                                </div>
                            </div>
                            <input type="hidden" name="user_id" onChange={handleInput} value={postSiteInput.user_id}  />
                            <input type="hidden" name="latitude" onChange={handleInput} value={postSiteInput.latitude}   />
                            <input type="hidden" name="longitude" onChange={handleInput} value={postSiteInput.longitude} />

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Project Name</label>
                                    <input type="text" name="project_name" onChange={handleInput} value={postSiteInput.project_name} className="form-control" placeholder="Enter Project Name" />
                                    <span className="validate-error-message">{errorlist.project_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="userName">Cuyds Of Dirt</label>
                                    <input type="text" name="cuyds_of_dirt_min" onChange={handleInput} value={postSiteInput.cuyds_of_dirt_min} className="form-control" placeholder="Enter Cuyds Of Dirt" />
                                    <span className="validate-error-message">{errorlist.cuyds_of_dirt_min}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">Cuyds Of Dirt Max</label>
                                    <input type="text" name="cuyds_of_dirt_max" onChange={handleInput} value={postSiteInput.cuyds_of_dirt_max} className="form-control" placeholder="Enter Cuyds Of Dirt Max" />
                                    <span className="validate-error-message">{errorlist.cuyds_of_dirt_max}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="address">Address</label>
                                    <input type="text" name="address" onChange={handleInput} value={postSiteInput.address} className="form-control" placeholder="Enter Address" />
                                    <span className="validate-error-message">{errorlist.address}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="description">Description</label>
                                    <textarea name="description" onChange={handleInput} value={postSiteInput.description} className="form-control" placeholder="Enter Description" />
                                    <span className="validate-error-message">{errorlist.description}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="image">Image</label>
                                    <input type="file" name="image" onChange={handleImage} className="form-control" multiple />
                                    <span className="validate-error-message">{errorlist.image}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="video">Video</label>
                                    <input type="file" name="video" onChange={handleVideo}  className="form-control" />
                                    <span className="validate-error-message">{errorlist.video}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="document">Document</label>
                                    <input type="file" name="document" onChange={handleDocument}  className="form-control" />
                                    <span className="validate-error-message">{errorlist.document}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="streetAddress2">Special Instruction</label>
                                   
                                 
                                    <textarea type="text" name="special_instruction" onChange={handleInput} value={postSiteInput.special_instruction} className="form-control" placeholder="Enter Special Instruction" />
                                    <span className="validate-error-message">{errorlist.special_instruction}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Name</label>
                                    <input type="text" name="name" onChange={handleInput} value={postSiteInput.name} className="form-control" placeholder="Enter Name" />
                                    <span className="validate-error-message">{errorlist.name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="Email">Email</label>
                                    <input type="text" name="email" onChange={handleInput} value={postSiteInput.e} className="form-control" placeholder="Enter Email" />
                                    <span className="validate-error-message">{errorlist.email}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="phoneNumber">Phone Number</label>
                                    <input type="text" name="phone" onChange={handleInput} value={postSiteInput.phone} className="form-control" placeholder="Enter Phone Number" />
                                    <span className="validate-error-message">{errorlist.phone}</span>
                                </div>
                            </div>
                            <div className="col-md-6 form-check mb-3 ml-2">
                                <input name="status" onChange={handleInput} value={postSiteInput.status} className="form-check-input"  id="inputRememberPassword" type="checkbox" value="1" />
                                <label className="form-check-label" htmlFor="inputRememberPassword">Status</label>
                                <span className="validate-error-message">{errorlist.status}</span>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default AddPostSite;